var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreProjectdetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_linear_3339_10926)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21.5H21.5V23H15.5V21.5ZM15.5 17.75H24.5V19.25H15.5V17.75ZM15.5 25.25H19.25V26.75H15.5V25.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 11.75H24.5V11C24.5 10.6022 24.342 10.2206 24.0607 9.93934C23.7794 9.65804 23.3978 9.5 23 9.5H17C16.6022 9.5 16.2206 9.65804 15.9393 9.93934C15.658 10.2206 15.5 10.6022 15.5 11V11.75H13.25C12.8522 11.75 12.4706 11.908 12.1893 12.1893C11.908 12.4706 11.75 12.8522 11.75 13.25V29C11.75 29.3978 11.908 29.7794 12.1893 30.0607C12.4706 30.342 12.8522 30.5 13.25 30.5H26.75C27.1478 30.5 27.5294 30.342 27.8107 30.0607C28.092 29.7794 28.25 29.3978 28.25 29V13.25C28.25 12.8522 28.092 12.4706 27.8107 12.1893C27.5294 11.908 27.1478 11.75 26.75 11.75ZM17 11H23V14H17V11ZM26.75 29H13.25V13.25H15.5V15.5H24.5V13.25H26.75V29Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3339_10926",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreProjectdetails);
export default __webpack_public_path__ + "static/media/More Project details.3a0dbb4b29b5f1f6a04e36dfdca13e93.svg";
export { ForwardRef as ReactComponent };